import React, { useState } from 'react'
import Chart from 'react-apexcharts'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'

import { infoIndicators } from '../heatmap/kpiUtils'
import { average, coefficientOfVariation, median, standardDeviation, quantile } from './utils'

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.primary.background,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell)

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow)

function Statistics(props) {

    const { kpis, networkIndicator, networkType } = props

    const [stateBar, setStateBar] = useState({
        graphicOne: {
            options: {
                bar: {
                    horizontal: true,
                },
                chart: {
                    id: 'basic-bar',
                },
                xaxis: {
                    categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
                },
                colors: ['#F44336', '#E91E63', '#9C27B0', 'red'],
            },
            series: [
                {
                    name: 'series-1',
                    data: [30, 40, 45, 50, 49, 60, 70, 91],
                },
            ],
        },
    })

    const parsedKpiValuesToTable = (kpis, networkIndicator) => {
        let dataCategories = [0, 0, 0, 0]
        kpis.forEach(item => {
            switch (networkIndicator) {
                case 'RSRP':
                    if (item >= -80) dataCategories[0]++
                    else if (item < -80 && item >= -90) dataCategories[1]++
                    else if (item < -90 && item >= -100) dataCategories[2]++
                    else if (item <= -100) dataCategories[3]++
                    break
                case 'RSRQ':
                    if (item >= -10) dataCategories[0]++
                    else if (item < -10 && item >= -15) dataCategories[1]++
                    else if (item < -15 && item >= -20) dataCategories[2]++
                    else if (item <= -20) dataCategories[3]++
                    break
                case 'RSSI':
                    if (item >= -65) dataCategories[0]++
                    else if (item < -65 && item >= -75) dataCategories[1]++
                    else if (item < -75 && item >= -85) dataCategories[2]++
                    else if (item <= -85) dataCategories[3]++
                    break
                case 'RSCP':
                    if (item >= -60) dataCategories[0]++
                    else if (item < -60 && item >= -75) dataCategories[1]++
                    else if (item < -75 && item >= -85) dataCategories[2]++
                    else if (item <= -85) dataCategories[3]++
                    break
                default:
                    dataCategories[0]++
            }
        })
        
        return dataCategories
    }

    const kpisFilteredByNetworkIndicator = kpis.filter(item => item.connectivity.signal[networkIndicator.toLowerCase()]).map(
        item => item.connectivity.signal[networkIndicator.toLowerCase()],
    )

    const getGraphicOne = (networkType, networkIndicator) => {
        let graphic = null
        graphic = {
            options: {
                bar: {
                    horizontal: true,
                },
                chart: {
                    id: 'kpis-bar',
                    type: 'bar',
                },
                colors: ['#13f739', '#ffe900', '#f29e18', '#F44336'],
                plotOptions: {
                    bar: {
                        distributed: true,
                    },
                },
                legend: {
                    show: false,
                },
                xaxis: {
                    categories: infoIndicators[networkType].map(item => [item[networkIndicator]]),
                    labels: {
                        style: {
                            colors: ['#13f739', 'yellow', '#f29e18', 'red'],
                            fontSize: '12px',
                        },
                    },
                },
            },
            series: [
                {
                    data: parsedKpiValuesToTable(kpisFilteredByNetworkIndicator, networkIndicator),
                },
            ],
        }

        return graphic
    }

    const avgKpis = Math.round(average(kpisFilteredByNetworkIndicator) * 100)/100
    const coefficientOfVariationKpis = Math.round(coefficientOfVariation(kpisFilteredByNetworkIndicator) * 100)/100
    const medianKpis = median(kpisFilteredByNetworkIndicator)
    const maxKpis = Math.max(...kpisFilteredByNetworkIndicator)
    const minKpis = Math.min(...kpisFilteredByNetworkIndicator)
    const stdDeviationKpis = Math.round(standardDeviation(kpisFilteredByNetworkIndicator) * 100)/100
    const quantile1Kpis = quantile(kpisFilteredByNetworkIndicator, 0.25)
    const quantile2Kpis = quantile(kpisFilteredByNetworkIndicator, 0.5)
    const quantile3Kpis = quantile(kpisFilteredByNetworkIndicator, 0.75)

    return (
        <Grid container spacing={2}>
            <Grid container direction="row" justify="center" alignItems="center">
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                >
                    <h2>{networkIndicator} KPI Overview</h2>
                    <Chart
                        options={getGraphicOne(networkType, networkIndicator).options}
                        series={getGraphicOne(networkType, networkIndicator).series}
                        type="bar"
                        width="400"
                    />
                </Grid>
                {/* <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={6}
                    xl={6}
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                >
                    <h2>Histogram</h2>
                    <Chart
                        options={stateBar.graphicOne.options}
                        series={stateBar.graphicOne.series}
                        type="bar"
                        width="400"
                    />
                </Grid> */}
            </Grid>
            <Grid container direction="row" justify="center" alignItems="center">
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={11}
                    lg={10}
                    xl={10}
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                    <h2>Statistics</h2>
                    <TableContainer component={Paper}>
                        <Table aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="center">Average</StyledTableCell>
                                    <StyledTableCell align="center">Media</StyledTableCell>
                                    <StyledTableCell align="center">Max</StyledTableCell>
                                    <StyledTableCell align="center">Min</StyledTableCell>
                                    <StyledTableCell align="center">
                                        Standard deviation
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        Coefficient of variation
                                    </StyledTableCell>
                                    <StyledTableCell align="center">1st Quarter</StyledTableCell>
                                    <StyledTableCell align="center">2nd Quarter</StyledTableCell>
                                    <StyledTableCell align="center">3rd Quarter</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <StyledTableRow>
                                    <StyledTableCell align="center">{avgKpis}</StyledTableCell>
                                    <StyledTableCell align="center">{medianKpis}</StyledTableCell>
                                    <StyledTableCell align="center">{maxKpis}</StyledTableCell>
                                    <StyledTableCell align="center">{minKpis}</StyledTableCell>
                                    <StyledTableCell align="center">
                                        {stdDeviationKpis}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        {coefficientOfVariationKpis}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        {quantile1Kpis}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        {quantile2Kpis}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        {quantile3Kpis}
                                    </StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Statistics
